module.exports = __webpack_public_path__ + "img/icon-152x152.1c0d7aa7.png";